import { useAssistant } from "../../config/assistantProfile.ts";

interface AssistantAvatarProps {
  size?: number;
  ring?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

/** The assistant's face, wherever she speaks. Maia's portrait is a full-bleed
 *  square, so the circular crop has to come from here rather than the asset. */
export function AssistantAvatar({ size = 32, ring = false, className, style }: AssistantAvatarProps) {
  const assistant = useAssistant();
  const { name, face } = assistant;

  if (ring) {
    return (
      <div
        className={className}
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          border: `${Math.max(2, Math.round(size / 36))}px solid ${assistant.ring?.color ?? "transparent"}`,
          overflow: "hidden",
          flexShrink: 0,
          ...style,
        }}
      >
        <img src={face} alt={name} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
      </div>
    );
  }

  return (
    <img
      src={face}
      alt={name}
      className={className}
      style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", ...style }}
    />
  );
}
